// extracted by mini-css-extract-plugin
module.exports = {"confirm-buttons":"modals_confirm-buttons__3GxGx","confirm-message":"modals_confirm-message__2fuMR"};